import React, { useState } from 'react';
import {
  InfoContainer,
  InfoToggleButton,
  ContainerContent,
} from './InputGroup.styled';
import { InfoIcon, ArrowIcon } from '../../SVGs/Icons';
import { Close } from '@material-ui/icons';

const STORAGE_KEY = 'ac_info_expanded';

const InfoComponent = () => {
  const [isInfoExpanded, setIsInfoExpanded] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === null ? true : stored === 'true';
  });

  const handleSetExpanded = value => {
    setIsInfoExpanded(value);
    localStorage.setItem(STORAGE_KEY, String(value));
  };

  return (
    <ContainerContent>
      {!isInfoExpanded && (
        <InfoToggleButton onClick={() => handleSetExpanded(!isInfoExpanded)}>
          <InfoIcon /> Creating an Automated Campaign.
        </InfoToggleButton>
      )}
      {isInfoExpanded && (
        <InfoContainer>
          <div>
            <InfoContainer.Title>
              <InfoIcon /> Creating an Automated Campaign.
            </InfoContainer.Title>
            <InfoContainer.Text>
              A Campaign is made up of an Audience and one or more Stages.
              <br /> <ArrowIcon /> The Audience defines who receives the
              messages. The
              <br /> <ArrowIcon /> Stages define what messages are sent and
              when.
              <br />
            </InfoContainer.Text>
          </div>
          <InfoContainer.Text>
            <br /> <strong>Step 1</strong> - Name the campaign and set up the
            stages.
            <br /> <strong>Step 2</strong> - Select audience
            <br /> <strong>Step 3</strong> - Review and publish
          </InfoContainer.Text>
          <InfoContainer.CloseButton onClick={() => handleSetExpanded(false)}>
            <Close />
          </InfoContainer.CloseButton>
        </InfoContainer>
      )}
    </ContainerContent>
  );
};

export default InfoComponent;
